
import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormGroup, Validators, FormArray } from '@angular/forms';
import { Observable, of, merge } from 'rxjs';
import { tap, map, switchMap, filter, takeUntil } from 'rxjs/operators';
import { get, pickBy, omitBy, mergeWith, isNil, set } from 'lodash';
import { Store, select } from '@ngrx/store';

import { getValue } from '@app/shared/utils/feature-utils';
import * as fromStore from '@app/core/store';
import { ScreenComponent } from '@core/features/screen.component';
import * as fromMaster from '@features/master/access-profile/store';


import { HttpClient } from '@angular/common/http';
import { FeatureService } from '@services/feature/feature.service';






import { environment } from '@env/environment';
const BASE_PATH = environment.basePath;
/**
* This Component manages the presentation logic of Edit screen
*
*/
@Component({
selector: 'app-master-access-profile',
templateUrl: './master-access-profile.component.html'
})
export class MasterAccessProfileComponent extends ScreenComponent implements OnInit {

  vars : any = {} ;
  loading$: Observable<boolean>;
  data$: Observable<any>;

typeclientsValues$ : Observable<any>;





  keys = `criarusuario,dadosCadastro,Perfis_de_Acesso,perfildeusuario_progressbar,label,lbl-perfil,lbl-subtitle,typeclients,c1,l1`;


        /**
        * Default Constructor of the component
        */
        constructor(
          private featureService: FeatureService,
private httpClient: HttpClient,

          
          
          router: Router,
          store: Store<fromMaster.State>,
            activeRoute: ActivatedRoute){
            super(activeRoute, store, router);
            }

            ngOnInit() {
            super.ngOnInit();
            this.id = this.activeRoute.snapshot.data.inputs.id;
            this.form = this.createForm();
            this.parentCtx = this.getParentCtxParam();
            this.ctx = this.getScreenCtx();
            this.store.dispatch(
             fromMaster.initStateAction({ ...this.params })
            );
            this.store.dispatch(
             fromMaster.initValueAction({ ...this.getPayload(), activeRoute: this.activeRoute })
            );
            
            this.data$ = this.store.pipe(
            fromStore.selectData(this.ctx),
              tap(item => this.init(item))
            );
            this.loading$ = this.store.select(fromStore.selectLoading, this.ctx);
            this.store
            .select(fromStore.checkValidation, this.ctx)
            .pipe(filter(value => value))
            .subscribe(data => {
              const isValid = this.form.valid;
              if (!isValid) {
                this.featureService.validateForm(this.form);
              }
              this.store.dispatch(fromMaster.updateDataAction({
                ...this.getActionPayload(),
                isValid,
                value: { ...this.data }
              }));
            });
            this.form.valueChanges.pipe(
              takeUntil(this.destroy$))
              .subscribe(value => {
              this.data = mergeWith(
                { ...this.data },
                { ...value },
                (target, source) => (source === null || source instanceof Array ? source : undefined)
              );
            });
            
          }

/**
* Initialize the component by the provided data object
* @param item
*/
init(item) {
  this.data = { ...pickBy(this.data), ...omitBy(item, isNil)};
  this.featureService.patchValue(this.data, this.form);
  
  

  
}

getPayload() {
  return {
    ...this.params,
    ...this.ctx,
    code: this.getCode(),
    keys: this.keys,
    parentCtx: { ...this.parentCtx }
  };
}

private getCode() {
  return this.parentCtx && this.parentCtx.code
    ? this.parentCtx.code
    : this.getParamCode();
}
private getParamCode() {
  const id = this.activeRoute.snapshot.params.id;
  return id && !id.startsWith('{') ? id : undefined;
}

private getParentCtxParam() {
  const id = this.activeRoute.snapshot.params.id;
  return id && id.startsWith('{') ? JSON.parse(id) : this.parentCtx;
}

getScreenCtx() {
  return fromStore.buildScreenCtx(
    'Master',
    'AccessProfile',
    this.screenId,
    this.parentCtx ? this.parentCtx.roleName : null,
    this.parentCtx ? this.parentCtx.rootId : null,
    this.parentCtx && this.parentCtx.roleName
    ? this.screenId + ',' + this.parentCtx.screenId
    : null);
}

/**
* Get the data to dispatch by ngrx actions
*/
getActionPayload() {
 return {
    ...this.params,
    ctx: {...this.ctx},
    activeRoute: this.activeRoute,
    vars: { ...this.vars },
    keys: this.keys,
    data: {...this.data},
    code: this.getCode(),
  }
}
    

createForm(): FormGroup {
    return this.featureService.formBuilder.group({
        perfildeusuario_progressbar: [null, []],
        dadosCadastro: [null, []],
        Perfis_de_Acesso: [null, []],
        typeclients: [null, []],
        c1: [null, []],
          });
  }

getTypeclientsValues(): Observable<any>{
    if (!this.typeclientsValues$) {
      this.store.dispatch(
        fromMaster.fetchFieldPossibleValuesAction({
          ...this.params,
          field: 'typeclients',
          activeRoute: this.activeRoute,
          keys: undefined,
          separator: '|',
          data: this.data,
          vars: { ...this.vars, field: 'typeclients' }
        })
      );
      this.typeclientsValues$= this.store.pipe(
        fromStore.selectPossibleValues(this.ctx, 'typeclients')
      );
 }     return this.typeclientsValues$;
  }









 




        /***
  * Executes the Anterior action
  * @return {void}
  **/
doAnterior(): void {
    this.store.dispatch(fromMaster.anteriorAction({...this.getActionPayload()}));
}

        /***
  * Executes the proximo action
  * @return {void}
  **/
doProximo(): void {
    this.store.dispatch(fromMaster.proximoAction({...this.getActionPayload()}));
}






  /**
   * Navigate to an auxiliary router outlet
   * @param {object} props
   */
  navigate(feature: string,
    screen: string,
    navigationType: string,
    roleName: string): void {
      this.featureService.navigate(
        feature,
        screen,
        navigationType,
        JSON.stringify({
          ...this.ctx,
          roleName,
          rootId: this.ctx.screenId,
        }),
        this.activeRoute
      );
    }
  /**
  * Get date format from the profile
  * @param {string} temporalType
  * @param {string} datePrecision
  * @return {string} the date format
  */
  getDateFormat(temporalType: string, datePrecision?: string): string {
    return this.featureService.profileService.getDateFormat(temporalType, datePrecision);
  }
}
